import CelMoney from "@/components/functionals/CelMoney";
import RenderCheckLabel from "@/components/functionals/RenderCheckLabel";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";

export default [
  {
    prop: "rncNcf",
    label: "rnc plataforma",
    minWidth: 150,
    sortable: true
  },
  {
    prop: "clienteCodeNcf",
    label: "Codigo Plataforma",
    minWidth: 170,
    sortable: true
  },
  {
    prop: "clientNameNcf",
    label: "Nombre Cliente Plataforma",
    minWidth: 230,
    sortable: true
  },
  {
    prop: "rnc",
    label: "rnc navision",
    minWidth: 130,
    sortable: true,
    fixed: "left"
  },
  {
    prop: "clientname",
    label: "Nombre Cliente",
    minWidth: 200,
    sortable: true,
    fixed: "left"
  },
  {
    prop: "clientecode",
    label: "Codigo cliente",
    minWidth: 150,
    sortable: true,
    fixed: "left"
  },

  {
    prop: "status",
    label: "Estado Empresa",
    sortable: true,
    align: "center",
    minWidth: 150,
    formatter: RenderCheckLabel
  },
  {
    prop: "ContractNo",
    label: "Numero Contrato",
    minWidth: 170,
    sortable: true,
    fixed: "left"
  },
  {
    prop: "EstatusContrato",
    label: "Estatus Contrato",
    align: "center",
    minWidth: 170,
    sortable: true
  },
  {
    prop: "razon",
    name: "Razon",
    label: "Motivo de Corte",
    minWidth: 150,
    sortable: true
  },
  {
    prop: "Invoices",
    label: "Facturas Pendiente",
    minWidth: 170,
    align: "center",
    sortable: true
  },
  {
    prop: "saldo",
    label: "Saldo Pendiente",
    minWidth: 150,

    sortable: true,
    formatter: CelMoney
  },
  {
    prop: "trackers_count",
    label: "Cantidad Terminales",
    minWidth: 180,
    align: "center",
    sortable: true
  },

  {
    prop: "daysInactive",
    label: "Días desactivados",
    minWidth: 170,
    sortable: true
  },
  {
    prop: "cutAt",
    label: "Fecha de corte",
    minWidth: 150,
    sortable: true,
    attrs: {
      onlyDate: true
    },
    formatter: DatetimeFormatter
  }
];
